var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationObserver',{ref:"observer",attrs:{"slim":true},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var passes = ref.passes;
return [_c('div',{class:_vm.cssClasses.formWrapperClasses},[_c('form',[_c('div',{class:_vm.cssClasses.formBody},[_vm._t("default")],2),_c('div',{class:_vm.cssClasses.formFooter},[_vm._t("footer")],2)])])]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }